<template>
  <AppModal
    :visible="visible"
    @close="close()"
  >
    <template #title>
      <h2 class="display-3 display-3_dark">
        {{ $t('message.assign_location.title') }}
      </h2>
    </template>
    <template #content>
      <p>{{ description }}</p>
      <v-autocomplete
        v-model="province"
        v-validate="validationRules.get('province')"
        :error-messages="errors.collect('province')"
        data-vv-name="province"
        :data-vv-as="$t('label.province')"
        :items="provinceList"
        cache-items
        item-text="name"
        item-value="province_id"
        :label="$t('label.province')"
        class="required-field"
        append-icon="expand_more"
      />
      <v-autocomplete
        v-model="rejon"
        v-validate="validationRules.get('province')"
        :error-messages="errors.collect('rejon')"
        data-vv-name="rejon"
        :data-vv-as="$t('label.area')"
        :items="rejonsList"
        item-value="value"
        item-text="description"
        :label="$t('label.area')"
        class="required-field"
        append-icon="expand_more"
        :disabled="province == null"
      >
        <template
          slot="item"
          slot-scope="props"
        >
          <span>{{ props.item.description }}</span>
        </template>
        <template
          slot="selection"
          slot-scope="props"
        >
          {{ props.item.description }}
        </template>
      </v-autocomplete>
    </template>
    <template #actions>
      <v-layout
        wrap
        justify-space-between
        :justify-center="$vuetify.breakpoint.xsOnly"
        align-center
      >
        <v-flex
          shrink
          order-xs2
          order-sm1
          :mt-3="$vuetify.breakpoint.xsOnly"
          :mr-3="$vuetify.breakpoint.smAndUp"
        >
          <a @click="cancel()">{{ $t('buttons.cancel') }}</a>
        </v-flex>
        <v-flex
          shrink
          order-xs1
          order-sm2
        >
          <v-btn
            color="sz_violet"
            :loading="loader"
            :disabled="province == null || rejon == null || loader"
            @click="assign()"
          >
            {{ $t('buttons.assign') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </AppModal>
</template>

<script>
import AppModal from '@/components/widgets/AppModal';
import validationRules from '@/constants/validationRules';

export default {
    name: 'AssignLocationDialog',
    components: { AppModal },
    props: {
        value: {
            type: Boolean
        },
        description: {
            type: String
        },
        loader: {
            type: Boolean,
            dafeult: false
        }
    },
    data () {
        return {
            validationRules,
            visible: false,
            province: null,
            rejon: null
        };
    },
    computed: {
        provinceList () {
            return this.$store.getters['defaultApi/getProvincesForFamiliesToAccept'];
        },
        rejonsList () {
            return this.$store.getters['search/getRegionsPerProvince'];
        }
    },
    watch: {
        value: {
            handler (val) {
                this.visible = val;
                if (!val) {
                    this.clearData();
                    this.$validator.reset();
                }
            }
        },
        province: {
            handler (val) {
                if (val) {
                    this.$store.dispatch('search/getRegionsPerProvince', val);
                }
            }
        }
    },
    methods: {
        close () {
            this.visible = false;
            this.$emit('close');
        },
        clearData () {
            this.province = null;
            this.rejon = null;
        },
        cancel () {
            this.clearData();
            this.close();
            this.$emit('cancel');
        },
        assign () {
            this.$emit('assign', this.rejon);
        }
    }
};
</script>

<style scoped></style>
